import { useState } from "react";

import { useAPI, useSwrFetch } from "hooks";

import { ActiveJoinCompanyRequestTable } from "./ActiveJoinCompanyRequestTable";

interface Props {
  company: CompanyDetailInfo;
  onSuccess: () => void;
}

export function ActiveJoinCompanyRequestTableContainer(props: Props) {
  const { company, onSuccess } = props;

  const [error, setError] = useState<string | null>(null);
  const { api } = useAPI();
  const {
    data: joinRequests,
    loading,
    error: fetchError,
    mutate,
  } = useSwrFetch<ActiveJoinCompanyRequest[]>({
    url: `/companies/${company.company.id}/active_join_requests`,
    errorMessage: "Failed to fetch active join requests.",
  });

  const onRespondToRequest = async (
    requestId: number,
    requestApproved: boolean,
  ) => {
    const body = { accepted: requestApproved };
    try {
      await api<unknown>(
        "post",
        `/join-company-requests/${requestId}/respond`,
        body,
      );
      setError(null);
      mutate();
      onSuccess();
    } catch (e: unknown) {
      const err = e as { response?: { data?: { message?: string } } };
      setError(
        err?.response?.data?.message ??
          "Failed to respond to join company request.",
      );
    }
  };

  return (
    <ActiveJoinCompanyRequestTable
      error={error ?? fetchError}
      loading={loading}
      joinRequests={joinRequests ?? []}
      onRespondToRequest={onRespondToRequest}
    />
  );
}
